package com.cybersoftsolution.cybersoftsolutionweb.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.AddButton
import com.cybersoftsolution.cybersoftsolutionweb.components.dropDowns.ButtonDropdown
import com.cybersoftsolution.cybersoftsolutionweb.components.dropDowns.CategoryDropdown
import com.cybersoftsolution.cybersoftsolutionweb.components.dropDowns.SimpleDropdown
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.AdminPageLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.IsAuthenticatedLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.switchs.MySwitch
import com.cybersoftsolution.cybersoftsolutionweb.models.Config
import com.cybersoftsolution.cybersoftsolutionweb.models.Post
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.AdminHomePageUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.CreatePostUI
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.cybersoftsolution.cybersoftsolutionweb.navigation.navigateTo
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.CreateStyle
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.getPostByIdUseCase
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.getServerConfigUseCase
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.setServerConfigUseCase
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.categoryDropDownId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.emailProviderDropDownId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.expirationTimesDropDownId
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px


@Composable
    fun AdminHomePage(){

        val context = rememberPageContext()
        val scope = rememberCoroutineScope()

        var state by remember { mutableStateOf( AdminHomePageUI() ) }

        val breakpoint = rememberBreakpoint()

        var isLoading by remember { mutableStateOf(false) }
        var currentScreenWidth by remember { mutableStateOf(window.innerWidth- 10) }


        val modifierSwitch = Modifier
            .margin(
                leftRight = if (isDesktop()) {18.px} else {0.px},
                topBottom = if (isDesktop()) {0.px} else {12.px},
            )
        val modifierCategory = Modifier
            .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
            .height(54.px)
            .padding(leftRight = 24.px)
            .margin(bottom = 12.px)
            .fontSize(14.px)


        LaunchedEffect(Unit){
            scope.getServerConfigUseCase(
                state = state,
                setLoading = {
                    isLoading = it
                },
                setState = {
                    state = it
                }
            )
        }




        AddButton(onCLick = {context.navigateTo(Screen.AdminCreate)} )

        AdminPageLayout(
            onScreenWidthChange = { newScreenWidth ->
                currentScreenWidth = newScreenWidth
            },
//            isLoading = isLoading,
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Top,
                modifier = Modifier
                    .fillMaxWidth(if (isDesktop()) {90.percent} else {95.percent})
                    .borderRadius(25.px)
                    .margin(topBottom = 24.px)
                    .padding(topBottom = 25.px, leftRight = 8.px)
            ){

                Box(
                    contentAlignment = Alignment.CenterStart,
                    modifier = modifierCategory

                ) {
                    MySwitch(
                        isChecked = state.serverConfig.isProductionMode,
                        text = "Modo Produccion",
                        onChange = {
//                            state = state.copy(serverConfig = state.serverConfig.copy(isProductionMode = !state.serverConfig.isProductionMode!!))
                            scope.launch {
                                setServerConfigUseCase(
                                    newServerConfig = Config(
                                        isProductionMode = !state.serverConfig.isProductionMode!!
                                    ),
                                    state = state,
                                    setLoading = {
                                        isLoading = it
                                    },
                                    setState = {
                                        state = it
                                    }
                                )
                            }
                        }
                    )
                }

                ButtonDropdown(
                    modifier = modifierCategory,
                    placeholder = "Proveedor de Correos",
                    items = state.serverConfig.emailSenders?: emptyList(),
                    style = CreateStyle,
                    selectedItem = "Proveedor de Correos : ${state.serverConfig.emailSender}",
                    id = emailProviderDropDownId,
                    onItemSelected = {
                        scope.launch {
                            setServerConfigUseCase(
                                newServerConfig = Config(
                                    emailSender = it
                                        .replace("Proveedor de Correos : ", "",true)
                                ),
                                state = state,
                                setLoading = {
                                    isLoading = it
                                },
                                setState = {
                                    state = it
                                }
                            )
                        }
                    }
                )

                ButtonDropdown(
                    modifier = modifierCategory,
                    placeholder = "Expiracion de OTP",
                    items = listOf("1 min", "3 min", "5 min", "10 min"),
                    style = CreateStyle,
                    selectedItem = "Expiracion de OTP : ${state.serverConfig.otpExpirationTimeInMin?.toInt()} min",
                    id = expirationTimesDropDownId,
                    onItemSelected = {
                        scope.launch {
                            setServerConfigUseCase(
                                newServerConfig = Config(
                                    otpExpirationTimeInMin = it
                                        .replace("Expiracion de OTP : ", "",true)
                                        .replace(" min", "",true)
                                        .toLong()
                                ),
                                state = state,
                                setLoading = {
                                    isLoading = it
                                },
                                setState = {
                                    state = it
                                }
                            )
                        }
                    }
                )






                Image(
                    modifier = Modifier
                        .width(
                            if (breakpoint >= Breakpoint.MD) 40.percent else 90.percent, //600.px,
//                            if (breakpoint >= Breakpoint.MD) 500.px else 90.percent, //600.px,
                        )
                        .margin(topBottom = 24.px),
                    src = Resources.Images.add_content,
                    alt = "Add Content Image",
                )
//                Text("THIS IS ADMIN HOME PAGE")

            }
        }






    }

    @Composable
    @Page(routeOverride = "home")
    fun Home() {

    IsAuthenticatedLayout(delay = 0L, asAdmin = true) {
        AdminHomePage()
    }



    }